import { render, staticRenderFns } from "./CalendarDesktop.vue?vue&type=template&id=91c41e86&scoped=true"
import script from "./CalendarDesktop.vue?vue&type=script&lang=ts&setup=true"
export * from "./CalendarDesktop.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CalendarDesktop.vue?vue&type=style&index=0&id=91c41e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c41e86",
  null
  
)

export default component.exports